import "./sidebar.css";
import Contato from "./components/Contato";
import { contato, habChart } from "./data/dados";
import Pie from "./components/Pie";
import { useTranslation } from "react-i18next";

export default function Sidebar() {
  const { i18n } = useTranslation('translation', { useSuspense: false });
  
  return (
    <aside className="sidebar">
      <div className="sidebar-content">
        <header className="section">
          {Object.keys(contato).length && <Contato contato={contato[i18n.language]} />}
        </header>

        <div className="chart-container">
          {habChart.map((item, key) => {
            return <Pie habilidade={item} key={key}/>
          })}
        </div>

      </div>
    </aside>
  );
}
